var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.83333C7 1.27999 7.44667 0.833328 8 0.833328C8.55333 0.833328 9 1.27999 9 1.83333V2.61333C11.0933 3.06666 12.6667 4.93333 12.6667 7.16666V11.1667L14 12.5V13.1667H2V12.5L3.33333 11.1667V7.16666C3.33333 4.93333 4.90667 3.06666 7 2.61333V1.83333ZM8 3.83333C9.84 3.83333 11.3333 5.32666 11.3333 7.16666V11.8333H4.66667V7.16666C4.66667 5.32666 6.16 3.83333 8 3.83333ZM6.67333 13.84C6.67333 14.5733 7.26667 15.1667 8 15.1667C8.73333 15.1667 9.32667 14.5733 9.32667 13.84H6.67333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification16W);
export default __webpack_public_path__ + "static/media/notification_16w.e0240d95619b562c8fec3f7e01e8fc3f.svg";
export { ForwardRef as ReactComponent };